import {
  Route,
  Routes,
  Navigate,
  BrowserRouter,
} from "react-router-dom";
import {onAuthStateChanged} from "firebase/auth";
import React, {useState} from "react";

//pages imports
import {AppContextProvider} from "./services/AppContext";
import {theme} from "./services/Theme";
import {ThemeProvider} from "@mui/material";
import Dashboard from "./dashboard-page/Dashboard";
import {LoginPage} from "./login-page/login-page";
import {auth} from "./services/firebaseApp";


function App() {

  const [user, setUser] = useState(false)

  onAuthStateChanged(auth, async (user) => {
    if (user) {
      setUser(true)
    } else {
      setUser(false)
    }
  })
  console.log('user')
  console.log(user)
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <AppContextProvider>
          <BrowserRouter>
            <Routes>
              {!user ? (
                <>
                  <Route path="/login" element={<LoginPage/>}/>
                  <Route path="/dashboard" element={<Navigate to="/login"/>}/>
                  <Route path="/" element={<Navigate to="/login"/>}/>
                  <Route path="*" element={<Navigate to="/login"/>}/>
                </>
              ) : (
                <>
                  <Route path="/login" element={<LoginPage user={user}/>}/>
                  <Route path="/dashboard" element={<Dashboard/>}/>
                  <Route path="/" element={<Navigate to="/dashboard"/>}/>
                  <Route path="*" element={<Navigate to="/dashboard"/>}/>
                </>
              )}
            </Routes>
          </BrowserRouter>
        </AppContextProvider>
      </ThemeProvider>
    </div>
  )
}

export default App;
